let VUE_APP_AUTH_URL = '';
if (process.env.NODE_ENV === 'production') {
    // 生产
    VUE_APP_AUTH_URL = 'https://auth-iam-account.app-prod.bjev.com.cn'
} else if(process.env.NODE_ENV === 'pre'){
    // 预生产
    VUE_APP_AUTH_URL = 'https://auth-iam-account.app-pre.bjev.com.cn'
}else{
    // 开发
    VUE_APP_AUTH_URL = 'https://auth-iam-account.app-dev.bjev.com.cn'
}
 
export default {
    // 签名秘钥
    signSecret: '916lWh2WMcbSWiHv',
    // 密码正则
    passwordReg: /^.{6,}$/,
    passwordRegDesc: '密码最少为6位字符',
    userUploadUrl: `${process.env.VUE_APP_API_ROOT}/user/file/upload`,
    // 启用微信功能
    enableWx: process.env.VUE_APP_WX == 'ON',
    // 登录地址
    VUE_APP_AUTH_URL 
}
